<!-- Footer Start -->
<footer id="contact" class=" iq-over-dark-90">
    <!-- Address -->
    <div class="footer-top">
      <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-4 " style="display: flex; align-items: center;">
              <div class="widget">
                <div class="textwidget ">
                  <p><img class="mb-4 img-fluid" src="../../../assets/imgs/logo/se2in_logo_fullwhite.png" alt="qloud">
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 mt-4 mt-lg-0 mt-md-0 menu-container">
              <div class="widget">
                <h4 class="footer-title">Menu</h4>
                <div>
                  <ul class="menu">
                    <li><a routerLink="" aria-current="page">Home</a></li>
                    <li><a routerLink="/products">{{'MENU_PRODUCTS' | translate}}</a></li>
                    <li><a routerLink="/hosting">{{'MENU_SERVICES' | translate}}</a></li>
                    <li><a routerLink="/downloads">{{'MENU_DOWNLOADS' | translate}}</a></li>
                    <li><a routerLink="/pricing-plan">{{'PRICING' | translate}}</a></li>
                    <li><a routerLink="/contact-us">{{'MENU_CONTACT' | translate}}</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 mt-lg-0 mt-4 menu-container">
              <div class="widget">
                <h4 class="footer-title">{{'MENU_CONTACT' | translate}}</h4>
                <div class="row">
                  <div class="col-sm-12">
                    <ul class="iq-contact">
                      <li><a><i class="fa fa-building"></i><span>(IT)² Interactive GmbH</span></a></li>
                      <li><a><i class="fa fa-home"></i><span>Joseph-von-Fraunhofer Str. 20, 44227 Dortmund</span></a></li>
                      <li><a href="mailto:info@it2in.de"><i class="fa fa-envelope"></i><span>info@it2in.de</span></a></li>
                      <li><a href="tel:02319700382"><i class="fa fa-phone"></i><span>02319700382</span></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- Address END -->
    <div class="copyright-footer">
      <div class="container">
        <div class="pt-3 pb-3">
          <div class="row justify-content-between">
            <div class="col-lg-12 col-md-12 text-lg-right text-md-center text-center">
              <span class="copyright">Copyright {{year}} se2.tech</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- Footer End -->
